// extracted by mini-css-extract-plugin
module.exports = {"googleEmbed":"GoogleEmbed_googleEmbed__zlF4e"};